import { CodeSectionProject } from '../../redux/kpis/definitions';

class ProjectSection {
  static DATOS_BASICOS = 'datos_basicos';
  static LOGICA_PROYECTO = 'logica_proyecto';
  static ASPECTOS_CLAVE = 'aspectos_clave';
  static ASISTENTE_CONVENIOS = 'asistente_convenios';
  static CALENDARIO = 'calendario';
  static CHECK = 'check';
  static FNC_CHECK = 'phone_check';
  static PAYMENT = 'payment';
  static KPIS = 'kpis';
  static KPIS_GF = 'kpis_gf';
  static KPIS_RVW = 'kpis_rvw';
  static NEW_KPIS = 'new_kpis';
  static INFORME_SEGUIMIENTO = 'informe_seguimiento';
  static EVALUACION_PROYECTO = 'evaluacion_proyecto';
  static EVALUACION_PERSONAL = 'evaluacion_personal';
  static FIRMA_CONVENIO = 'firma_convenio';
  static FIRMA_SEGUIMIENTO = 'firma_seguimiento';
  static FICHA_PERSONAL = 'ficha_personal';
  static FICHA_SEGUIMIENTO = 'ficha_seguimiento';
  static SEGUIMIENTO_PAGO = 'seguimiento_pago';

  constructor(private code: string) {}

  public value(): string {
    return this.code;
  }

  public valueTyped(): CodeSectionProject {
    return this.value() as CodeSectionProject;
  }

  public static toArray(): string[] {
    return [
      ProjectSection.DATOS_BASICOS,
      ProjectSection.LOGICA_PROYECTO,
      ProjectSection.ASPECTOS_CLAVE,
      ProjectSection.ASISTENTE_CONVENIOS,
      ProjectSection.CALENDARIO,
      ProjectSection.CHECK,
      ProjectSection.FNC_CHECK,
      ProjectSection.PAYMENT,
      ProjectSection.KPIS,
      ProjectSection.KPIS_GF,
      ProjectSection.KPIS_RVW,
      ProjectSection.NEW_KPIS,
      ProjectSection.INFORME_SEGUIMIENTO,
      ProjectSection.EVALUACION_PROYECTO,
      ProjectSection.EVALUACION_PERSONAL,
      ProjectSection.FIRMA_CONVENIO,
      ProjectSection.FIRMA_SEGUIMIENTO,
      ProjectSection.FICHA_PERSONAL,
      ProjectSection.FICHA_SEGUIMIENTO,
      ProjectSection.SEGUIMIENTO_PAGO,
    ];
  }

  public isDatosBasicos(): boolean {
    return this.code === ProjectSection.DATOS_BASICOS;
  }

  public isLogicaProyecto(): boolean {
    return this.code === ProjectSection.LOGICA_PROYECTO;
  }

  public isAspectosClave(): boolean {
    return this.code === ProjectSection.ASPECTOS_CLAVE;
  }

  public isAsistenteConvenios(): boolean {
    return this.code === ProjectSection.ASISTENTE_CONVENIOS;
  }

  public isCalendario(): boolean {
    return this.code === ProjectSection.CALENDARIO;
  }

  public isCheck(): boolean {
    return this.code === ProjectSection.CHECK;
  }

  public isFncCheck(): boolean {
    return this.code === ProjectSection.FNC_CHECK;
  }

  public isPayment(): boolean {
    return this.code === ProjectSection.PAYMENT;
  }

  public isKpis(): boolean {
    return this.code === ProjectSection.KPIS;
  }

  public isKpisGf(): boolean {
    return this.code === ProjectSection.KPIS_GF;
  }

  public isKpisRvw(): boolean {
    return this.code === ProjectSection.KPIS_RVW;
  }

  public isNewKpis(): boolean {
    return this.code === ProjectSection.NEW_KPIS;
  }

  public isInformeSeguimiento(): boolean {
    return this.code === ProjectSection.INFORME_SEGUIMIENTO;
  }

  public isEvaluacionProyecto(): boolean {
    return this.code === ProjectSection.EVALUACION_PROYECTO;
  }

  public isEvaluacionPersonal(): boolean {
    return this.code === ProjectSection.EVALUACION_PERSONAL;
  }

  public isFirmaConvenio(): boolean {
    return this.code === ProjectSection.FIRMA_CONVENIO;
  }

  public isFirmaSeguimiento(): boolean {
    return this.code === ProjectSection.FIRMA_SEGUIMIENTO;
  }

  public isFichaPersonal(): boolean {
    return this.code === ProjectSection.FICHA_PERSONAL;
  }

  public isFichaSeguimiento(): boolean {
    return this.code === ProjectSection.FICHA_SEGUIMIENTO;
  }

  public isSeguimientoPago(): boolean {
    return this.code === ProjectSection.SEGUIMIENTO_PAGO;
  }

  public isTrackingAllowedSection(): boolean {
    return this.isKpis() || this.isKpisRvw() || this.isNewKpis();
  }
}

export default ProjectSection;
